export async function createGeneratedProject({ create, dismissToast, setToast }) {
  try {
    await create({ openBrainDump: true });
    dismissToast();
    return true;
  } catch (error) {
    console.error("Failed to create generated project", error);
    setToast("Failed to create project. Please try again.");
    return false;
  }
}
